import {
  api, getOptions,
} from './helpers';

const getCountMultiple = (payload) => api.post('/document/getCountMultiple', payload, getOptions());

export default {
  getCountMultiple,
};
